import { Icon } from '@shared/components/Icon';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { fadeIn } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import classNames from './overlay.module.css';

interface FileDropListenerOverlayProps {
  /**
   * What the overlay says while a file is held over the target.
   *
   * Defaults to attaching, which is what a drop does nearly everywhere. A surface where it does
   * something else passes its own line, rather than building a second overlay that has to be kept
   * looking like this one.
   */
  message?: string;
}

export function FileDropListenerOverlay({ message }: FileDropListenerOverlayProps) {
  return (
    <View className={[classNames.fileDropListenerOverlay, fadeIn]}>
      <View className={classNames.content}>
        <Icon name="imagestack" gridSize={6} />
        <Text weight="bold">{message ?? i18n('form.dragAndDropToAttach')}</Text>
      </View>
      <View className={classNames.border} />
    </View>
  );
}
